import { UserService } from '@/service/user.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';
@Injectable({
  providedIn: 'root',
})
export class UserRequiresOnboardingGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService,
    private keycloakService: KeycloakService,
  ) {}

  canActivate(): Observable<boolean> {
    const roles = this.keycloakService.getUserRoles();
    const userIsAuthenticated = this.keycloakService.isLoggedIn();

    if (!userIsAuthenticated) {
      return of(true);
    }

    return this.userService.getUserInfoForGuard().pipe(
      map((user) => {
        // If we get here, we have a valid response
        if (!user || !user.firstName || !user.birthYear || !user.zipCode) {
          console.log('USER MISSING REQUIRED FIELDS');
          // User exists but is missing required onboarding fields
          this.router.navigate(['/user-onboarding']);
          return false;
        }

        if (roles.includes('company') && !user.company) {
          this.router.navigate(['/company-onboarding']);
          return false;
        }

        return true;
      }),
      catchError((error) => {
        console.error('Error getting user info', error);
        // On error, redirect to onboarding to be safe
        this.router.navigate(['/home']);
        return of(false);
      }),
    );
  }
}
